module.exports = __webpack_public_path__ + "img/766-2ede81.png";